import '@/assets/css/linked-cigars.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './style.scss';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Typography } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import axios from 'axios';
import { ContentState, EditorState } from 'draft-js';
import Hashids from 'hashids';
import htmlToDraft from 'html-to-draftjs';
import React, { useCallback, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import paginationFactory, {
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import DataTable from 'react-data-table-component';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async-creatable';
import Select from 'react-select/creatable';
import { toast as Toast } from 'react-toastify';
import {
  Collapse,
  Modal,
  Spinner,
  Tooltip,
  UncontrolledTooltip,
} from 'reactstrap';
import { v4 as uuidv4 } from 'uuid';

import Breadcrumb from '@/components/common/breadcrumb.component';
import DebounceSearchBar from '@/components/debounce-search-bar';
import CsvDropzone from '@/components/dropzone';
import Icon from '@/components/icon';
import NoDataIndicator from '@/components/no-data-indicator';
import Button from '@/components/overrides/button';
import StandalonePagination from '@/components/pagination/standalone';
import RowMoreOptions from '@/components/table/row-more-options';
import TableLoader from '@/components/table-loader';
import { Constants } from '@/constants';
import {
  getAllProducts as getAllProductsAction,
  postProduct as postProductAction,
  putProduct as putProductAction,
} from '@/redux/actions/shop.actions';
import { uploadToS3 } from '@/utils/imageUtils';

import Cigar from '../../../models/Cigar';
import { defaultPackageType } from '../editor';
import {
  ProductCigarCell,
  ProductCigarSuggestions,
  type SuggestedCigar,
} from './product-cigar-cell';
import ProductManagerFilterDrawer from './product-manager-filter-drawer';
import {
  buildProductManagerFilterParams,
  countProductManagerFilters,
  DEFAULT_PRODUCT_MANAGER_FILTERS,
} from './product-manager-filters';

const hashids = new Hashids('', 12);

const defaultSorted = [{ dataField: 'name', order: 'asc' }];

const cellEditProps = {
  mode: 'dbclick',
};

const defaults = {
  editorState: EditorState.createEmpty(),
  selectedId: null,
  selectedImageUrl: null,
  selectedProduct: {},
  imagesToAttach: [],
  imagesToRemove: [],
  selectedCategories: null,
  selectedPackageType: null,
  selectedPackageQuantity: 1,
  selectedAvailability: 'Out Of Stock',
  selectedImagesToAttach: [],
  selectedImagesToRemove: [],
  productImportType: 'single_import',
  uploading: false,
  importing: false,
  selectedRecords: null,
  selectedRecordCount: 0,
  selectedInventoryFile: null,
  selectedCigarSuggestion: 0,
};

const extraDetails = [
  'Pyramid',
  'Short Robusto',
  'Robusto',
  'Cigarillos',
  'Short Torpedo',
  'Torpedo',
  'Short Churchill',
  'Churchill',
  'Lancero',
  'Panatela',
  'Toro',
  'Double Corona',
  'Corona Gordo',
  'Corona Gorda',
  'Gordo',
  'Double Toro',
  'Gran Robusto',
  'Double Robusto',
  'Salomon',
  'Presidente',
  'Prominente',
  'Belicoso',
  'Double Perfecto',
  'Petit Corona',
  'La Punta Perfecto',
  'Perfecto',
  'Corona',
  'Wedge',
  'Rothschild',
  'Lonsdale',
  'Trabuco',
  'Tronco',
  'Tin',
  'Jar',
  'Box Pressed',
  'Box-Pressed',
  'Boxpressed',
  'Fresh Pack',
  'Tubo',
  'Tubos',
  'Coffin',
  'La Fuerza',
  '1400cc',
  'No. 10',
  'No. 20',
  'No. 30',
  'No. 40',
  'No. 50',
  'No. 60',
  'No. 70',
  'No. 80',
  'No. 90',
  'No. 1',
  'No. 2',
  'No. 3',
  'No. 4',
  'No. 5',
  'No. 6',
  'No. 7',
  'No. 8',
  'No. 9',
  'No.1',
  'No.2',
  'No.3',
  'No.4',
  'No.5',
  'No.6',
  'No.7',
  'No.8',
  'No.9',
  '5 pack',
  '5 Pack',
  '5pk',
  '5 pk',
  '5 Pk',
];

function removeStringsFromArray(array, query) {
  const regex = new RegExp(array.join('|'), 'g');
  return query.replace(regex, '');
}

let defaultShops = [];

const ShopTable = (props) => {
  const navigate = useNavigate();

  const [state, setState] = useState({
    page: 1,
    sizePerPage: 30,
    showProductModal: false,
    showImportModal: false,
    showImporterDatatable: false,
    showImageUrlModal: false,
    showLinkCigarModal: false,
    showFilterDrawer: false,
    selectedProductImages: [],
    linkedCigars: [],
    vitolaOptions: [],
    anchorEl: null,
    showMoreMenu: false,
    number: null,
    edited: false,
    ...defaults,
  });

  const [selectedUrl, setSelectedUrl] = useState('');
  const [selectedInventoryFile, setSelectedInventoryFile] = useState(null);
  const [showLinkCigarModal, setShowLinkCigarModal] = useState(false);
  const [defaultCigars, setDefaultCigars] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState(
    DEFAULT_PRODUCT_MANAGER_FILTERS
  );
  const [filterDraft, setFilterDraft] = useState(
    DEFAULT_PRODUCT_MANAGER_FILTERS
  );

  // --- Helper functions converted to useState setters ---
  const toggleTooltip = useCallback(
    (key) => () => {
      setState((prev) => ({ ...prev, [key]: !prev[key] }));
    },
    []
  );

  const handleProductChange = useCallback(
    (key) => (e) => {
      setState((prev) => ({
        ...prev,
        selectedProduct: { ...prev.selectedProduct, [key]: e.target.value },
      }));
    },
    []
  );

  const handleInputChange = useCallback(
    (key) => (e) => {
      console.log('handleInputChange', key, e.target.value);
      setState((prev) => ({ ...prev, [key]: e.target.value }));
    },
    []
  );

  const handleSelectChange = useCallback(
    (key) => (value) => {
      console.log('handleSelectChange', key, value);
      setState((prev) => ({ ...prev, [key]: value }));
    },
    []
  );

  const handleRadioChange = useCallback(
    (key) => (e) => {
      setState((prev) => ({ ...prev, [key]: e.target.value }));
    },
    []
  );

  const handleLinkedCigarChange = useCallback(
    (index, type) => (value) => {
      setState((prev) => {
        const linkedCigars = [...prev.linkedCigars];
        const linkedCigar = linkedCigars[index] || {};
        linkedCigar[type] = value;
        linkedCigars[index] = linkedCigar;
        // If updating the cigar, load vitolas
        if (type === 'cigar') {
          loadVitolas(index);
        }
        return { ...prev, linkedCigars };
      });
    },
    []
  );

  const handleLinkedCigarInputChange = useCallback(
    (index, type) => (e) => {
      setState((prev) => {
        const linkedCigars = [...prev.linkedCigars];
        const linkedCigar = linkedCigars[index] || {};
        linkedCigar[type] = e.target.value;
        linkedCigars[index] = linkedCigar;
        if (type === 'cigar') {
          loadVitolas(index);
        }
        return { ...prev, linkedCigars };
      });
    },
    []
  );

  // --- Functions that interact with API ---
  const getCigarSuggestions = useCallback((query) => {
    axios
      .get(`${Constants.clientPath}/cigars/search`, {
        params: { q: removeStringsFromArray(extraDetails, query).trim() },
      })
      .then((response) => {
        setState((prev) => ({
          ...prev,
          fetchedCigarSuggestions: true,
          cigarSuggestions: response.data.map((cigar) => ({
            value: cigar.id,
            label: cigar.full_name,
            image_url: Cigar.getBandImage(cigar),
          })),
        }));
      })
      .catch((err) => {
        console.error(err);
        setState((prev) => ({ ...prev, fetchedCigarSuggestions: true }));
      });
  }, []);

  const getProductSuggestions = useCallback((query) => {
    axios
      .get(`${Constants.shopPath}/products/search`, {
        params: { q: query, limit: 5 },
        headers: {},
      })
      .then((response) => {
        setState((prev) => ({
          ...prev,
          fetchedProductSuggestions: true,
          productSuggestions: response.data.filter(
            (product) => product.contents && product.contents.length > 0
          ),
        }));
      })
      .catch((err) => {
        console.error(err);
        setState((prev) => ({ ...prev, fetchedProductSuggestions: true }));
      });
  }, []);

  const loadVitolas = useCallback(
    (index) => {
      const linkDetails = state.linkedCigars[index] || {};
      if (linkDetails.cigar && linkDetails.cigar.value) {
        axios
          .get(
            `${Constants.clientPath}/cigars/${linkDetails.cigar.value}/vitolas`
          )
          .then((res) => {
            setState((prev) => {
              const allVitolaOptions = { ...prev.vitolaOptions };
              allVitolaOptions[index] = res.data.map((vitola) => ({
                value: vitola.id,
                label: vitola.formatted_name,
              }));
              return { ...prev, vitolaOptions: allVitolaOptions };
            });
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    [state.linkedCigars]
  );

  const syncImages = (product) => {
    // TODO Show loading indicator
    axios
      .put(`${Constants.apiPath}/shop/products/${product.id}/images/migrate`)
      .then((res) => {
        console.log(res);
        // TODO Toast instead
        // this.setState({
        //   message: {
        //     type: 'success',
        //     show: true,
        //     title: 'Success!',
        //     text: 'The images have been successfully updated.',
        //   },
        // });
      })
      .catch((err) => {
        console.log(err);
        // TODO Toast instead
        // this.setState({
        //   message: {
        //     type: 'info',
        //     show: true,
        //     title: 'No Images',
        //     text: 'Unable to update images for this product. If the product has images, please check the logs for an error.',
        //   },
        // });
      });
  };

  const syncPackaging = (product) => {
    // TODO Show loading indicator
    axios
      .put(
        `${Constants.apiPath}/shop/products/packaging/missing?reference=${product.reference}`
      )
      .then((res) => {
        console.log(res);
        // TODO Toast instead
        // this.setState({
        //   message: {
        //     type: 'success',
        //     show: true,
        //     title: 'Success!',
        //     text: 'The packaging has been successfully updated.',
        //   },
        // });
      })
      .catch((err) => {
        console.log(err);
        // TODO Toast instead
        // this.setState({
        //   message: {
        //     type: 'warning',
        //     show: true,
        //     title: 'Not Updated',
        //     text: 'Unable to update packaging for this product. Please check the logs for an error.',
        //   },
        // });
      });
  };

  const checkPrices = (product) => {
    // TODO Show loading indicator
    axios
      .get(
        `${Constants.apiPath}/shop/products/${product.id}/pricecheck?reference=${product.reference}`
      )
      .then((res) => {
        console.log(res);
        // TODO Toast instead
        // updateState({
        //   message: {
        //     type: 'success',
        //     show: true,
        //     title: 'Success!',
        //     text: 'The prices have been successfully updated.',
        //   },
        // });
      })
      .catch((err) => {
        console.log(err);
        // TODO Toast instead
        // updateState({
        //   message: {
        //     type: 'warning',
        //     show: true,
        //     title: 'Not Updated',
        //     text: 'Unable to update prices for this product. Please check the logs for an error.',
        //   },
        // });
      });
  };

  // --- Modal open/close handlers ---
  const keyForType = (type) => {
    switch (type) {
      case 'product':
        return 'showProductModal';
      case 'import':
        return 'showImportModal';
      case 'imageurl':
        return 'showImageUrlModal';
      case 'cigar':
        return 'showLinkCigarModal';
      case 'filter':
        return 'showFilterDrawer';
      case 'datatable':
        return 'showImporterDatatable';
      default:
        return '';
    }
  };

  const onOpenModal = useCallback(
    (type, row = null) => {
      if (row && type === 'product') {
        getCigarSuggestions(row.name);
        getProductSuggestions(row.reference);
        let categories = [];
        let packagingType = null;
        let packagingQuantity = 1;
        let editorState = EditorState.createEmpty();
        if (row.description) {
          const contentBlock = htmlToDraft(row.description);
          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(
              contentBlock.contentBlocks
            );
            editorState = EditorState.createWithContent(contentState);
          }
        }
        if (row.categories) {
          categories = row.categories.map((category) => ({
            value: category,
            label: category,
          }));
        }
        if (row.packaging) {
          packagingType = {
            label: row.packaging.type,
            value: row.packaging.type,
          };
          packagingQuantity = row.packaging.quantity;
        }
        if (row.price && typeof row.price === 'number' && row.price > 0) {
          row.price = row.price.toFixed(2);
        }
        const linkedCigars = (row.contents || []).map((content) => ({
          cigar: {
            label: content.cigar?.full_name || content.cigar?.name || '',
            value:
              content.cigar?.id || content.cigar?.cigar_id || content.cigar_id,
          },
          vitola: content.vitola
            ? {
                label: content.vitola.formatted_name || '',
                value: content.vitola.id || content.vitola_id,
              }
            : null,
          quantity: content.quantity || 1,
        }));
        setState((prev) => ({
          ...prev,
          editorState,
          linkedCigars,
          selectedProduct: row,
          selectedProductImages: row.images,
          selectedAvailability: row.availability
            ? { value: row.availability, label: row.availability }
            : '',
          selectedCategories: categories,
          selectedPackageType: packagingType,
          selectedPackageQuantity: packagingQuantity,
          selectedVenue: row.venue
            ? { value: row.venue.id, label: formatVenueLabel(row.venue) }
            : null,
        }));
        console.log('Showing link cigar modal...');
        setShowLinkCigarModal(true);
      } else if (row && type === 'cigar') {
        if (!state.fetchedCigarSuggestions) {
          getCigarSuggestions(row.name);
        }
        if (row.contents && row.contents.length) {
          const linkedCigars = row.contents.map((content) => ({
            cigar: { label: content.cigar.full_name, value: content.cigar.id },
            vitola: {
              label: content.vitola ? content.vitola.formatted_name : '',
              value: content.vitola ? content.vitola.id : '',
            },
            quantity: content.quantity,
          }));
          setState((prev) => ({
            ...prev,
            linkedCigars,
            [keyForType(type)]: true,
          }));
        } else {
          setState((prev) => ({ ...prev, [keyForType(type)]: true }));
        }
      } else if (type === 'filter') {
        setFilterDraft(appliedFilters);
        setState((prev) => ({ ...prev, showFilterDrawer: true }));
      } else {
        setState((prev) => ({ ...prev, [keyForType(type)]: true }));
      }
    },
    [
      appliedFilters,
      getCigarSuggestions,
      getProductSuggestions,
      state.fetchedCigarSuggestions,
    ]
  );

  const onCloseModal = useCallback((type) => {
    if (type === 'product') {
      setState((prev) => ({ ...prev, [keyForType(type)]: false, ...defaults }));
    } else if (type === 'cigar') {
      setState((prev) => ({
        ...prev,
        linkedCigars: [],
        [keyForType(type)]: false,
      }));
    } else if (type === 'import' || type === 'imageurl') {
      setState((prev) => ({
        ...prev,
        [keyForType(type)]: false,
        selectedImageUrl: null,
      }));
      setSelectedUrl('');
    } else if (type === 'datatable') {
      setState((prev) => ({ ...prev, ...defaults, [keyForType(type)]: false }));
    } else {
      setState((prev) => ({ ...prev, [keyForType(type)]: false }));
    }
  }, []);

  const updateState = (s) => {
    setState((prev) => ({ ...prev, ...s }));
  };

  const handleTableChange = useCallback(
    (
      type,
      { page, sizePerPage, sortField, sortOrder, searchText },
      filters = appliedFilters
    ) => {
      const nextPage = page ?? state.page;
      const nextSizePerPage = sizePerPage ?? state.sizePerPage;
      const nextSearchText = searchText ?? state.searchText;
      const nextSortField = sortField ?? state.sortField;
      const nextSortOrder = sortOrder ?? state.sortOrder;
      props.getAllProducts(nextPage, nextSizePerPage, nextSearchText, {
        ...buildProductManagerFilterParams(filters),
        sort: nextSortField,
        direction: nextSortOrder,
      });
      setState((prev) => ({
        ...prev,
        tableChangeType: type,
        page: nextPage,
        sizePerPage: nextSizePerPage,
        searchText: nextSearchText,
        sortField: nextSortField,
        sortOrder: nextSortOrder,
      }));
    },
    [appliedFilters, state, props]
  );

  const onSaveModal = (type) => {
    if (type === 'filter') {
      onCloseModal('filter');
      handleTableChange(null, { page: 1, sizePerPage: state.sizePerPage });
    } else if (type === 'datatable') {
      const { selectedImportVenue, importOptions } = state;
      if (!selectedImportVenue || !selectedImportVenue.value) {
        alert('Please include the venue to link these products to');
        return;
      }
      if (!importOptions) {
        alert('Please select the import type');
        return;
      }
      updateState({ uploading: true });
      axios
        .post(
          `${Constants.apiPath}/shop/products/inventory/venues/${selectedImportVenue.value}/datasources/sign`,
          {
            filetype: selectedInventoryFile.type,
          }
        )
        .then((result) => {
          console.debug('Signed response:');
          console.debug(JSON.stringify(result.data.signed_url));
          const uploadOptions = {
            method: 'PUT',
            headers: {
              'Content-Type': selectedInventoryFile.type,
            },
            body: selectedInventoryFile,
          };

          console.debug(result.data);

          console.debug('Direct upload in progress...');
          fetch(result.data.signed_url, uploadOptions)
            .then(async (res) => {
              if (res.ok && result.data.datasource_url) {
                console.debug('S3 success');
                let batchEndpoint = `${Constants.apiPath}/shop/products/inventory/batch`;
                if (importOptions === 'update_images') {
                  batchEndpoint = `${batchEndpoint}/images`;
                }
                console.debug('Kicking off step function...');
                await axios
                  .post(batchEndpoint, {
                    venue_id: selectedImportVenue.value,
                    datasource_url: result.data.datasource_url,
                    update_only: importOptions === 'update_only',
                  })
                  .then(() => {
                    // TODO Update local state with the new datasource? Or just show alert that it's importing and they will be notified when complete?
                    updateState({
                      uploading: false,
                      showImportModal: false,
                      showImporterDatatable: false,
                    });
                    Toast.success('You will receive an email when complete', {
                      heading: 'Product Sync Started',
                      position: 'top-right',
                    });
                  })
                  .catch((err) => {
                    console.error(err);
                    updateState({ uploading: false });
                    // TODO Alert the user with ModalDialog? Reuse it for all of these catches...
                    alert(
                      'Something went wrong. Please contact our support team at support@boxpressd.com'
                    );
                  });
              } else {
                console.error('No data URL...');
                updateState({ uploading: false });
                // Alert admins - something went wrong
                // Sentry.setExtra('s3_signed_url_response', {
                //   id: result.id,
                //   datasource_url: result.datasource_url,
                // });
                // Sentry.captureException('Unable to upload media to S3');
                alert(
                  'Something went wrong. Please contact our support team at support@boxpressd.com'
                );
              }
            })
            .catch((err) => {
              updateState({ uploading: false });
              console.debug('S3 failure:');
              console.debug(err);
              alert(
                'Something went wrong. Please contact our support team at support@boxpressd.com'
              );
            });
        })
        .catch((err) => {
          updateState({ uploading: false });
          console.error(err);
          alert(
            'Something went wrong. Please contact our support team at support@boxpressd.com'
          );
        });
    } else if (type === 'import') {
      console.log('state.productImportType', state.productImportType);
      if (state.productImportType === 'single_import') {
        // FIXME Redux or helper class?
        // this.props.scrapeUrl(url)
        //     .then((product) => {
        //         this.onCloseModal('import');
        //         this.onOpenModal('product', product)
        //     })
        // FIXME Why is selectedUrl still an empty string
        console.log(`Getting product details for selectedUrl: ${selectedUrl}`);
        updateState({ importing: true });

        axios
          .get(`${Constants.apiPath}/scrape/product`, {
            params: {
              url: selectedUrl,
            },
          })
          .then((res) => {
            console.log(JSON.stringify(res.data));
            updateState({ importing: false });
            onCloseModal('import');
            onOpenModal('product', res.data);
          })
          .catch((e) => {
            console.error(e.message);
            updateState({
              importing: false,
              message: {
                type: 'error',
                show: true,
                title: 'Failed to scrape',
                text: 'There was a problem scraping this URL. Please try again or contact an admin.',
              },
            });
          });
      } else if (state.productImportType === 'bulk_import') {
        // TODO Test for a file and then process initial rows to display in new modal with shop select, similar to business panel
      } else {
        // TODO Do something? Make the user select one? Not sure when this would happen...
      }
    }
  };

  const applyFilters = () => {
    const nextFilters = { ...filterDraft };
    setAppliedFilters(nextFilters);
    setState((prev) => ({ ...prev, page: 1, showFilterDrawer: false }));
    handleTableChange(
      'filter',
      { page: 1, sizePerPage: state.sizePerPage },
      nextFilters
    );
  };

  const resetFilters = () => {
    const nextFilters = { ...DEFAULT_PRODUCT_MANAGER_FILTERS };
    setFilterDraft(nextFilters);
    setAppliedFilters(nextFilters);
    setState((prev) => ({ ...prev, page: 1, showFilterDrawer: false }));
    handleTableChange(
      'filter',
      { page: 1, sizePerPage: state.sizePerPage },
      nextFilters
    );
  };

  const updateProductMedia = useCallback(
    (productId) => {
      const {
        selectedImagesToAttach,
        selectedImagesToRemove,
        tableChangeType,
        page,
        sizePerPage,
        searchText,
      } = state;
      if (
        selectedImagesToAttach.length > 0 ||
        selectedImagesToRemove.length > 0
      ) {
        axios
          .put(`${Constants.apiPath}/shop/products/${productId}/media`, {
            add: selectedImagesToAttach.map((url) => ({ url })),
            remove: selectedImagesToRemove,
          })
          .then(() => {
            handleTableChange(tableChangeType, {
              page,
              sizePerPage,
              searchText,
            });
          })
          .catch((err) => console.error(err));
      }
    },
    [state, handleTableChange]
  );

  const uploadMedia = useCallback(
    (blob, extension, type) => {
      const uuid = uuidv4();
      const productHash = hashids.encode(
        state.selectedProduct ? state.selectedProduct.id : new Date().getTime()
      );
      const filename = `${productHash}-${type}.${extension}`;
      uploadToS3(blob, `products/${type}`, filename, uuid)
        .then((res) => {
          setState((prev) => ({
            ...prev,
            uploadingMedia: false,
            [type]: res.data.media_url,
            selectedProductImages: [
              ...prev.selectedProductImages,
              { url: res.data.media_url },
            ],
          }));
          if (state.productImages && state.productImages.dropzone) {
            state.productImages.dropzone.removeAllFiles();
            const messageDiv =
              state.productImages.dropzone.element.closest('.dz-message');
            if (messageDiv) {
              messageDiv.style.display = 'block';
            } else {
              state.productImages.dropzone.element.children[0].style.display =
                'block';
            }
          }
        })
        .catch((err) => {
          setState((prev) => ({ ...prev, uploadingMedia: false }));
          console.error(err);
        });
    },
    [state.selectedProduct, state.productImages]
  );

  // --- Formatters for table cells ---
  const imageFormatter = useCallback((cell) => {
    let url = cell;
    if (url) {
      if (url.indexOf('http') === -1) {
        url = url.replace('//', '');
        url = `https://${url}`;
      }
      if (
        window.location.hostname === 'admin.sigaro.io' ||
        window.location.hostname === 'admin.boxpressd.io'
      ) {
        url = url.replace('/products/', '/products/100x100/');
      }
      return (
        <img
          style={{ maxWidth: 75 }}
          src={url}
          onClick={() => {}}
          alt="product"
        />
      );
    }
    return <div />;
  }, []);

  const venueFormatter = useCallback((cell, row) => {
    return row.venue ? row.venue.name : 'N/A';
  }, []);

  const packagingFormatter = useCallback((cell) => {
    if (cell) {
      let formatted = `${cell.type} of ${cell.quantity}`;
      if (
        cell.type === 'Sampler' ||
        cell.type === 'Single' ||
        cell.type === 'Accessory' ||
        cell.type === 'Subscription'
      ) {
        formatted = cell.type;
      }
      return <>{formatted}</>;
    }
    return null;
  }, []);

  const vitolaFormatter = useCallback((contents, row) => {
    if (
      contents &&
      contents.length &&
      row.packaging &&
      row.packaging.type !== 'Sampler' &&
      row.packaging.type !== 'Subscription'
    ) {
      if (contents[0].vitola) {
        return <>{contents[0].vitola.formatted_name}</>;
      }
    } else if (
      contents &&
      contents.length &&
      row.packaging &&
      row.packaging.type === 'Sampler'
    ) {
      return <>Varies</>;
    }
    return null;
  }, []);

  const priceFormatter = useCallback((cell) => {
    if (cell) {
      let price = cell;
      if (
        typeof price === 'number' ||
        (typeof price === 'string' && price.indexOf('$') === -1)
      ) {
        price = `$${parseFloat(cell).toFixed(2)}`;
      }
      return <label>{price}</label>;
    }
    return null;
  }, []);

  const statusFormatter = useCallback((cell, row) => {
    if (cell === 'ok') {
      return (
        <div style={{ marginLeft: 15 }}>
          <Icon name="check-circle" color="#198754" />
        </div>
      );
    }
    if (cell === 'warn') {
      return (
        <div style={{ marginLeft: 15 }}>
          <span id={`warning-${row.id}`}>
            <Icon name="alert-triangle" color="#ffc107" />
          </span>
          <UncontrolledTooltip placement="top" target={`warning-${row.id}`}>
            <ul>
              {row.status_message.map((message, i) => (
                <li key={i}>-{message}</li>
              ))}
            </ul>
          </UncontrolledTooltip>
        </div>
      );
    }
    if (cell === 'unlinked') {
      return (
        <div style={{ marginLeft: 15 }}>
          <span id={`unlinked-${row.id}`}>
            <Icon name="link" color="#dc3545" />
          </span>
          <UncontrolledTooltip placement="top" target={`unlinked-${row.id}`}>
            <ul>
              {row.status_message.map((message, i) => (
                <li key={i}>-{message}</li>
              ))}
            </ul>
          </UncontrolledTooltip>
        </div>
      );
    }
    if (cell === 'unlinked-warn') {
      return (
        <div style={{ marginLeft: 15 }}>
          <span id={`unlinked-${row.id}`}>
            <Icon name="link" color="#ffc107" />
          </span>
          <UncontrolledTooltip placement="top" target={`unlinked-${row.id}`}>
            <ul>
              {row.status_message.map((message, i) => (
                <li key={i}>-{message}</li>
              ))}
            </ul>
          </UncontrolledTooltip>
        </div>
      );
    }
    if (cell === 'missing-attribute') {
      return (
        <div style={{ marginLeft: 15 }}>
          <span id={`missing-attribute-${row.id}`}>
            <Icon name="alert-circle" color="#dc3545" />
          </span>
          <UncontrolledTooltip
            placement="top"
            target={`missing-attribute-${row.id}`}
          >
            <ul>
              {row.status_message.map((message, i) => (
                <li key={i}>-{message}</li>
              ))}
            </ul>
          </UncontrolledTooltip>
        </div>
      );
    }
    return (
      <div style={{ marginLeft: 15 }}>
        <span id={`error-${row.id}`}>
          <Icon name="alert-triangle" color="#dc3545" />
        </span>
        <UncontrolledTooltip placement="top" target={`error-${row.id}`}>
          <ul>
            {row.status_message.map((message, i) => (
              <li key={i}>-{message}</li>
            ))}
          </ul>
        </UncontrolledTooltip>
      </div>
    );
  }, []);

  const loadCigars = (searchTerm, callback) => {
    console.log(`${Constants.apiPath}/cigars?q=${searchTerm}`);
    if (searchTerm.length > 3) {
      return axios
        .get(`${Constants.apiPath}/cigars?q=${searchTerm}`)
        .then((res) => {
          // console.log(res.data);
          const cigars = res.data.map((cigar) => ({
            value: cigar.id,
            label: cigar.full_name,
            vitolas: cigar.vitolas,
          }));

          console.log('cigars:', cigars);
          setDefaultCigars(cigars);

          callback(cigars);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  const renderLinkedCigarsRow = (type, index) => {
    console.debug('Linked cigars row:');
    console.debug(state.linkedCigars);
    console.debug(`Index: ${index}`);
    const linkDetails = state.linkedCigars[index] || {};
    if (type === 'Sampler') {
      return (
        <div
          className="row"
          style={{
            marginLeft: linkDetails.cigar ? 10 : 0,
            marginRight: linkDetails.cigar ? 10 : 0,
          }}
        >
          <div
            className={linkDetails.cigar ? 'col-md-5' : 'col-md-12'}
            style={{ padding: 0 }}
          >
            <span>{linkDetails.cigar ? 'Cigar' : 'Search Cigar To Link'}</span>
            <AsyncSelect
              value={linkDetails.cigar}
              onChange={handleLinkedCigarChange(index, 'cigar')}
              loadOptions={loadCigars.bind(this)}
              defaultOptions={
                state.cigarSuggestions?.length
                  ? state.cigarSuggestions
                  : defaultCigars
              }
              isOptionSelected={(option) => linkDetails.cigar === option}
            />
          </div>
          {linkDetails.cigar && (
            <div className="col-md-4">
              <span>Vitola</span>
              <Select
                value={linkDetails.vitola}
                onChange={handleLinkedCigarChange(index, 'vitola')}
                options={
                  state.vitolaOptions[index]?.length
                    ? state.vitolaOptions[index]
                    : []
                }
                isOptionSelected={(option) => linkDetails.vitola === option}
              />
            </div>
          )}
          {linkDetails.cigar && (
            <div className="col-md-2">
              <span>Quantity</span>
              <input
                className="form-control"
                value={linkDetails.quantity || 1}
                type="number"
                onChange={handleLinkedCigarInputChange(index, 'quantity')}
              />
            </div>
          )}
          {linkDetails.cigar && (
            <div
              className="col-md-1"
              style={{
                lineHeight: '60px',
                marginTop: 8,
              }}
            >
              <Icon
                name="trash"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  // TODO Remove the linkDetails from state.linkedCigars (or a clone to only apply on Save)
                  const { linkedCigars } = state;
                  linkedCigars.splice(index, 1);
                  updateState({ linkedCigars });
                }}
              />
            </div>
          )}
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col-md-6">
          <span>Cigar</span>
          <AsyncSelect
            value={linkDetails.cigar}
            onChange={handleLinkedCigarChange(index, 'cigar')}
            loadOptions={loadCigars.bind(this)}
            defaultOptions={
              state.cigarSuggestions?.length
                ? state.cigarSuggestions
                : defaultCigars
            }
            isOptionSelected={(option) => linkDetails.cigar === option}
          />
        </div>
        <div className="col-md-6">
          <span>Vitola</span>
          <Select
            value={linkDetails.vitola}
            onChange={handleLinkedCigarChange(index, 'vitola')}
            options={
              state.vitolaOptions[index]?.length
                ? state.vitolaOptions[index]
                : []
            }
            isOptionSelected={(option) => linkDetails.vitola === option}
          />
        </div>
      </div>
    );
  };

  const renderLinkedCigars = () => {
    if (state.selectedPackageType) {
      if (
        state.selectedPackageType.value === 'Sampler' ||
        state.selectedPackageType.value === 'Subscription'
      ) {
        const linkedCigars = [...state.linkedCigars];
        linkedCigars.push({}); // Adds an extra empty object to the end FIXME Should only be in the editor
        return (
          <div className="linked-cigar-block">
            {linkedCigars.map((cigar, index) =>
              renderLinkedCigarsRow(state.selectedPackageType.value, index)
            )}
            {/* <button type="button" className="btn btn-outline-primary" onClick={() => {}}>Add Another</button> */}
          </div>
        );
      }
      return (
        <div>{renderLinkedCigarsRow(state.selectedPackageType.value, 0)}</div>
      );
    }
    return (
      <div>
        <span>Please set the product package type before linking cigars</span>
        <AsyncSelect
          value={state.selectedPackageType}
          onChange={handleSelectChange('selectedPackageType')}
          defaultOptions={defaultPackageType.map((value) => ({
            value,
            label: value,
          }))}
          isOptionSelected={(option) => state.selectedPackageType === option}
        />
      </div>
    );
  };

  const handleApproveSuggestedCigar = (
    productId: number,
    suggestion: SuggestedCigar
  ) => {
    // TODO: Wire to the product/cigar suggestion approval endpoint.
    console.info('Approve suggested cigar', { productId, suggestion });
    Toast.info('Suggestion approval endpoint not implemented yet', {
      position: 'top-right',
    });
  };

  const handleRejectSuggestedCigar = (
    productId: number,
    suggestion: SuggestedCigar
  ) => {
    // TODO: Wire to the product/cigar suggestion rejection endpoint.
    console.info('Reject suggested cigar', { productId, suggestion });
    Toast.info('Suggestion rejection endpoint not implemented yet', {
      position: 'top-right',
    });
  };

  const renderLinkCigarModal = () => (
    <Modal
      isOpen={showLinkCigarModal}
      onClosed={() => setShowLinkCigarModal(false)}
      size="lg"
    >
      <div className="modal-header">
        <h5 className="modal-title">
          {`Link cigars${state.selectedProduct.name && ` to ${state.selectedProduct.name}`}`}
        </h5>
      </div>
      <div className="modal-body">
        <ProductCigarSuggestions
          product={state.selectedProduct}
          onApproveSuggestion={handleApproveSuggestedCigar}
          onRejectSuggestion={handleRejectSuggestedCigar}
        />
        {renderLinkedCigars()}
      </div>
      <div className="modal-footer">
        <Button onClick={() => setShowLinkCigarModal(false)}>{'Cancel'}</Button>
        <Button
          disabled={state.submitting}
          onClick={() => {
            const { linkedCigars, selectedProduct } = state;
            selectedProduct.contents = linkedCigars.map((item) => ({
              cigar_id: item.cigar.value,
              cigar: {
                id: item.cigar.value,
                full_name: item.cigar.label,
              },
              vitola_id: item.vitola?.value || undefined,
              vitola: item.vitola
                ? {
                    id: item.vitola.value,
                    formatted_name: item.vitola.label,
                  }
                : undefined,
              quantity: item.quantity || 1,
            }));
            // FIXME Update the table row
            updateState({ selectedProduct });
            setShowLinkCigarModal(false);
          }}
          variant="contained"
          color="primary"
        >
          {'Set'}
        </Button>
      </div>
    </Modal>
  );

  const actionDropdown = useCallback(
    (index, product) => (
      <RowMoreOptions
        row={index}
        items={[
          {
            type: 'MenuItem',
            onClick: () => {
              // FIXME Rename modal
              onOpenModal('product', product);
            },
            title: 'Link Cigars',
          },
          {
            type: 'MenuItem',
            onClick: () => {
              syncImages(product);
            },
            title: 'Sync Images',
          },
          {
            type: 'MenuItem',
            onClick: () => {
              syncPackaging(product);
            },
            title: 'Sync Packaging Info',
          },
          {
            type: 'MenuItem',
            onClick: () => {
              axios
                .post(
                  `${Constants.apiPath}/actions/products/${product.id}/search/index`
                )
                .then(() => {
                  Toast.success('Successfully re-indexed products', {
                    heading: product.name,
                    position: 'top-right',
                  });
                })
                .catch((error) => {
                  console.error(error);
                  Toast.error('Unable to re-index product', {
                    heading: product.name,
                    position: 'top-right',
                  });
                });
            },
            title: 'Re-index in Search',
          },
          {
            type: 'MenuItem',
            onClick: () => {
              checkPrices(product);
            },
            title: 'Price Check',
          },
          {
            type: 'MenuItem',
            onClick: () => {
              alert(
                'Not yet implemented! Currently, products are disabled by setting the quantity to 0 in the database.'
              );
            },
            style: { color: '#ff4700' },
            title: 'Delete',
          },
        ]}
        onShow={() => {
          document
            .querySelector(`#dropdown-actions-${index}`)
            .classList.add('d-none');
        }}
      />
    ),
    []
  );

  const editBtnFormatter = useCallback(
    (cell, row, index) => {
      return (
        <div style={{ width: 68, float: 'right' }}>
          <div id={`dropdown-actions-${index}`} className="d-none">
            <Icon
              name="edit2"
              className="ml-1 mr-3"
              style={{
                cursor: 'pointer',
                display: 'inline',
                height: 18,
                width: 18,
              }}
              onClick={() => {
                const product = row;
                navigate(
                  `/shop/editor/${product.hash_id || hashids.encode(product.id)}`,
                  { state: { product } }
                );
              }}
            />
            {actionDropdown(index, row)}
          </div>
        </div>
      );
    },
    [actionDropdown]
  );

  const closeAlert = useCallback(() => {
    setState((prev) => ({
      ...prev,
      message: { show: false, title: '', text: '' },
    }));
  }, []);

  const importModal = () => (
    <Modal
      isOpen={state.showImportModal}
      onClosed={() => onCloseModal('import')}
      toggle={() => onCloseModal('import')}
    >
      <div className="modal-header">
        <h5 className="modal-title">Import Products</h5>
      </div>
      <div className="modal-body">
        <RadioGroup
          row
          aria-label="product import type"
          name="product_import_type"
          value={state.productImportType}
          onChange={handleRadioChange('productImportType')}
        >
          <FormControlLabel
            value="single_import"
            control={<Radio color="primary" />}
            label="Single product from URL"
          />
          <FormControlLabel
            value="bulk_import"
            control={<Radio color="primary" />}
            label="Bulk import from file"
          />
        </RadioGroup>
        {/* FIXME Move this single import modal to the producteditor exclusively - default to CSV here */}
        <Collapse isOpen={state.productImportType === 'single_import'}>
          URL{' '}
          <span id="urlTooltip">
            <Icon name="alert-circle" />
          </span>
          <Tooltip
            placement="top"
            isOpen={state.showUrlTooltip}
            target="urlTooltip"
            toggle={toggleTooltip('showUrlTooltip')}
          >
            Importable URLs include: <br />
            <br />
            <ul>
              <li>https://www.meierdutch.com/item/[*]</li>
            </ul>
          </Tooltip>
          <input
            className="form-control"
            type="text"
            name="import-url"
            value={selectedUrl}
            onChange={(e) => {
              console.log('New value', e.target.value);
              setSelectedUrl(e.target.value);
            }}
          />
        </Collapse>
        <Collapse isOpen={state.productImportType === 'bulk_import'}>
          <div>File Upload</div>
          <CsvDropzone
            id="dropzone"
            accept={{
              'text/csv': ['.csv'],
              'application/vnd.ms-excel': ['.csv'],
            }}
            config={{ postUrl: 'no-url', iconFiletypes: ['.csv'] }}
            dropText="Add csv file or drop here to upload"
            onChange={(files) => {
              console.log('New files onChange:', files);
              if (files?.length) {
                console.log('CSV files:', files);
                setSelectedInventoryFile(files[0]);
              }
            }}
            getJson={(json) => {
              const selectedRecords = json.slice(0, 10);
              setState((prev) => ({
                ...prev,
                selectedRecords,
                selectedRecordCount: json.length,
              }));

              onCloseModal('import');
              onOpenModal('datatable');
            }}
            style={{ minHeight: 'auto' }}
          />
        </Collapse>
      </div>
      <div className="modal-footer">
        <Button onClick={() => onCloseModal('import')}>Cancel</Button>
        <Button
          disabled={state.importing}
          onClick={() => onSaveModal('import')}
          variant="contained"
          color="secondary"
        >
          {state.importing && (
            <Spinner
              type="border"
              color="light"
              size="sm"
              style={{ marginRight: 10 }}
            />
          )}
          {state.importing ? 'Importing' : 'Import'}
        </Button>
      </div>
    </Modal>
  );

  const renderImporterDatatableModal = () => {
    const {
      selectedRecords,
      selectedRecordCount,
      showImporterDatatable,
      uploading,
    } = state;
    return (
      <Modal
        isOpen={showImporterDatatable}
        toggle={() => onCloseModal('datatable')}
        onClosed={() => onCloseModal('datatable')}
      >
        <div className="modal-header">
          <h5 className="modal-title h2">Confirm Import Details</h5>
          <Button
            className="close"
            color=""
            onClick={() => onCloseModal('datatable')}
          >
            <Icon name="x" />
          </Button>
        </div>
        <div className="modal-body">
          {selectedRecords && selectedRecordCount && (
            <div>
              <div>
                <RadioGroup
                  aria-label="import options"
                  name="import_options"
                  value={state.importOptions}
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      importOptions: e.target.value,
                    }))
                  }
                >
                  <FormControlLabel
                    value="update_only"
                    sx={{
                      alignItems: 'flex-start',
                      mb: 1.5,
                    }}
                    control={<Radio sx={{ mt: 0.25 }} />}
                    label={
                      <div>
                        <Typography variant="body1" fontWeight={600}>
                          Update existing records only
                        </Typography>

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 0.25 }}
                        >
                          Use this option if you want to update prices and stock
                          count for products you have already listed.
                        </Typography>
                      </div>
                    }
                  />
                  <FormControlLabel
                    value="update_images"
                    sx={{
                      alignItems: 'flex-start',
                      mb: 1.5,
                    }}
                    control={<Radio sx={{ mt: 0.25 }} />}
                    label={
                      <div>
                        <Typography variant="body1" fontWeight={600}>
                          Update missing images only
                        </Typography>

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 0.25 }}
                        >
                          Use this option if you want to bulk import images for
                          products. No other data will be updated.
                        </Typography>
                      </div>
                    }
                  />
                  <FormControlLabel
                    value="import_all"
                    sx={{
                      alignItems: 'flex-start',
                      mb: 1.5,
                    }}
                    control={<Radio sx={{ mt: 0.25 }} />}
                    label={
                      <div>
                        <Typography variant="body1" fontWeight={600}>
                          Import missing products and update existing
                        </Typography>

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mt: 0.25 }}
                        >
                          Use this option if you want to import any products not
                          already listed in your shop in addition to updating
                          prices and stock count.
                        </Typography>
                      </div>
                    }
                  />
                </RadioGroup>
              </div>
              {/* FIXME It should be able to use the venue ID from the CSV so multiple can be included in one batch */}
              <div>Venue:</div>
              <AsyncSelect
                value={state.selectedImportVenue}
                onChange={handleSelectChange('selectedImportVenue')}
                isOptionSelected={(option) =>
                  state.selectedImportVenue === option
                }
                loadOptions={loadShops}
              />
              <div style={{ marginTop: 26 }}>
                {`Showing the first ${selectedRecords.length < 10 ? selectedRecords.length : 10} out of ${selectedRecordCount} records`}
              </div>
              <DataTable
                noHeader
                pagination={false}
                columns={Object.keys(selectedRecords[0] || {}).map((name) => {
                  const maxLength = Math.max(
                    name.length,
                    ...selectedRecords
                      .slice(0, 10)
                      .map((r) => String(r[name] || '').length)
                  );

                  const width = Math.min(
                    Math.max(maxLength * 8, 120), // minimum
                    300 // maximum
                  );

                  return {
                    name,
                    selector: (row) => row[name],
                    width: `${width}px`,
                    wrap: true,
                  };
                })}
                data={selectedRecords}
                selectableRows={false}
              />
            </div>
          )}
        </div>
        <div className="modal-footer">
          <Button onClick={() => onCloseModal('datatable')}>Cancel</Button>
          <Button
            disabled={uploading}
            onClick={() => onSaveModal('datatable')}
            variant="contained"
            color="secondary"
          >
            {uploading && (
              <Spinner
                type="border"
                color="light"
                size="sm"
                style={{ marginRight: 10 }}
              />
            )}
            {uploading ? 'Importing...' : 'Import'}
          </Button>
        </div>
      </Modal>
    );
  };

  const formatVenueLabel = useCallback((venue) => {
    let label = venue.name;
    if (venue.location && venue.location.formatted_address) {
      label += ` - ${venue.location.formatted_address}`;
    } else if (venue.website) {
      label += ` - ${venue.website}`;
    }
    return label;
  }, []);

  const loadShops = useCallback(
    (searchTerm, callback) => {
      axios
        .get(`${Constants.clientPath}/venues/search?q=${searchTerm}`)
        .then((res) => {
          const shops = res.data.map((venue) => ({
            value: venue.id,
            label: formatVenueLabel(venue),
          }));
          defaultShops = shops;
          callback(shops);
        })
        .catch((err) => console.error(err));
    },
    [formatVenueLabel]
  );

  // --- Render ---
  const { data, totalSize, loadingProducts } = props.ShopManager;
  const columns = [
    {
      dataField: 'image_url',
      text: '',
      formatter: imageFormatter,
      sort: false,
      editable: false,
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
    },
    {
      dataField: 'venue',
      text: 'Sold By',
      formatter: venueFormatter,
    },
    {
      dataField: 'packaging',
      text: 'Packaging',
      formatter: packagingFormatter,
    },
    {
      dataField: 'contents',
      text: 'Vitola',
      formatter: vitolaFormatter,
    },
    {
      dataField: 'cigar',
      text: 'Cigar',
      formatter: (cell, row) => (
        <ProductCigarCell
          product={row}
          onApproveSuggestion={handleApproveSuggestedCigar}
          onRejectSuggestion={handleRejectSuggestedCigar}
          onReviewSuggestions={(product) =>
            navigate(
              `/shop/editor/${product.hash_id || hashids.encode(product.id)}`,
              { state: { product } }
            )
          }
        />
      ),
      sort: false,
      editable: false,
      style: { minWidth: 280, maxWidth: 320 },
    },
    {
      dataField: 'reference',
      text: 'Reference',
      sort: true,
    },
    {
      dataField: 'upc',
      text: 'UPC',
      sort: true,
    },
    {
      dataField: 'sale_price',
      text: 'Price',
      formatter: priceFormatter,
      sort: true,
    },
    {
      dataField: 'status',
      text: 'Status',
      formatter: statusFormatter,
      sort: true,
    },
    {
      dataField: 'edit',
      text: '',
      formatter: editBtnFormatter,
    },
  ];

  const rowEvents = {
    onMouseEnter: (e, row, index) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        .classList.remove('d-none');
    },
    onMouseLeave: (e, row, index) => {
      document
        .querySelector(`#dropdown-actions-${index}`)
        .classList.add('d-none');
    },
    onDoubleClick: (e, row, index) => {},
  };

  const pageButtonRenderer = ({ page: currentPage, active, onPageChange }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(currentPage);
    };
    const classname = active
      ? 'btn btn-secondary'
      : 'btn btn-outline-secondary';
    return (
      <li className="page-item pl-1" key={currentPage}>
        <a href="#" onClick={handleClick} className={classname}>
          {currentPage}
        </a>
      </li>
    );
  };

  return (
    <div>
      <Breadcrumb
        title="Product Manager"
        label="Product Manager"
        parent="Shop"
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="mb-0">
              <div className="datatable-react">
                <ToolkitProvider
                  keyField="id"
                  data={data}
                  columns={columns}
                  search
                >
                  {(toolkitprops) => (
                    <div>
                      <DebounceSearchBar
                        {...toolkitprops.searchProps}
                        placeholder="Search products..."
                        onChange={() =>
                          setState((prev) => ({ ...prev, page: 1 }))
                        }
                      />
                      <button
                        className="btn btn-secondary"
                        onClick={(event) =>
                          setState((prev) => ({
                            ...prev,
                            anchorEl: event.currentTarget,
                            showMoreMenu: true,
                          }))
                        }
                        style={{
                          padding: '6px 14px',
                          float: 'right',
                          marginLeft: '10px',
                        }}
                      >
                        <MoreVertIcon />
                      </button>
                      <Menu
                        id="demo-customized-menu"
                        MenuListProps={{
                          'aria-labelledby': 'demo-customized-button',
                        }}
                        anchorEl={state.anchorEl}
                        open={state.showMoreMenu}
                        onClose={() =>
                          setState((prev) => ({
                            ...prev,
                            anchorEl: null,
                            showMoreMenu: false,
                          }))
                        }
                      >
                        <MenuItem
                          disableRipple
                          onClick={() => {
                            setState((prev) => ({
                              ...prev,
                              anchorEl: null,
                              showMoreMenu: false,
                            }));
                            axios
                              .post(
                                `${Constants.apiPath}/actions/products/search/index`
                              )
                              .then(() => {
                                Toast.success(
                                  'Successfully re-indexed products',
                                  {
                                    heading: 'Products',
                                    position: 'top-right',
                                  }
                                );
                              })
                              .catch((error) => {
                                console.error(error);
                                Toast.error('Unable to re-index product', {
                                  heading: 'Products',
                                  position: 'top-right',
                                });
                              });
                          }}
                        >
                          Re-index All Products
                        </MenuItem>
                      </Menu>
                      <button
                        className="btn btn-primary"
                        style={{ float: 'right' }}
                        onClick={() => navigate('/shop/editor/new')}
                      >
                        {isMobile ? (
                          <i className="icon icon-plus" />
                        ) : (
                          'Add Product'
                        )}
                      </button>
                      <button
                        className="btn btn-secondary mr-2"
                        onClick={() => onOpenModal('import')}
                        style={
                          isMobile
                            ? { padding: '6px 14px', float: 'right' }
                            : { float: 'right' }
                        }
                      >
                        {isMobile ? (
                          <i className="icon icon-import" />
                        ) : (
                          'Import Product'
                        )}
                      </button>
                      <button
                        className="btn btn-secondary mr-2"
                        onClick={() => onOpenModal('filter')}
                        style={
                          isMobile
                            ? { padding: '6px 14px', float: 'right' }
                            : { float: 'right' }
                        }
                      >
                        {isMobile ? (
                          <i className="icon icon-filter" />
                        ) : (
                          `Filter${countProductManagerFilters(appliedFilters) ? ` (${countProductManagerFilters(appliedFilters)})` : ''}`
                        )}
                      </button>
                      <PaginationProvider
                        pagination={paginationFactory({
                          pageButtonRenderer,
                          page: state.page,
                          sizePerPage: state.sizePerPage,
                          custom: true,
                          totalSize,
                          showTotal: true,
                        })}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <div>
                            <BootstrapTable
                              remote
                              keyField="id"
                              data={data}
                              columns={columns}
                              rowEvents={rowEvents}
                              defaultSorted={defaultSorted}
                              wrapperClasses="table-responsive"
                              {...paginationTableProps}
                              cellEdit={cellEditFactory(cellEditProps)}
                              onTableChange={handleTableChange}
                              noDataIndication={() =>
                                !loadingProducts ? (
                                  <NoDataIndicator message="No products found matching filters or search query." />
                                ) : (
                                  <TableLoader />
                                )
                              }
                              {...toolkitprops.baseProps}
                            />
                            <PaginationTotalStandalone {...paginationProps} />
                            <div
                              style={{
                                width: 200,
                                display: 'inline-block',
                                float: 'right',
                              }}
                            />
                            <div style={{ display: 'flex', paddingBottom: 20 }}>
                              <div style={{ flex: 1 }}>
                                <StandalonePagination
                                  paginationProps={paginationProps}
                                />
                              </div>
                              <div>
                                <SizePerPageDropdownStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </PaginationProvider>
                      {importModal()}
                      {renderImporterDatatableModal()}
                      <ProductManagerFilterDrawer
                        open={state.showFilterDrawer}
                        filters={filterDraft}
                        defaultShops={defaultShops}
                        loadShops={loadShops}
                        onChange={setFilterDraft}
                        onClose={() =>
                          setState((prev) => ({
                            ...prev,
                            showFilterDrawer: false,
                          }))
                        }
                        onApply={applyFilters}
                        onReset={resetFilters}
                      />
                      {renderLinkCigarModal()}
                    </div>
                  )}
                </ToolkitProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ ShopManager }) => ({ ShopManager });

export default connect(mapStateToProps, {
  getAllProducts: getAllProductsAction,
  postProduct: postProductAction,
  putProduct: putProductAction,
})(ShopTable);
